import cloneDeep from 'lodash/cloneDeep';

import { currentYear } from '@webapp/common/lib/date';
import { tempId } from '@webapp/common/lib/utils';
import type { Question } from '@webapp/common/resources/entities/question';
import { initialQuestion } from '@webapp/common/resources/entities/question';
import { QuestionType } from '@webapp/common/resources/survey';

export interface SmileType {
    name: string;
    value: string;
    smiles: Array<string>;
}

export const smileTypes: Readonly<Array<SmileType>> = [
    {
        name: '5 - смайлы',
        value: '5-smile',
        smiles: ['angry', 'bad', 'normal', 'good', 'perfect'],
    },
    {
        name: '3 - смайлы',
        value: '3-smile',
        smiles: ['angry', 'normal', 'perfect'],
    },
    {
        name: '2 - смайлы',
        value: '2-smile',
        smiles: ['angry', 'perfect'],
    },
    {
        name: '2 - рука',
        value: '2-hand',
        smiles: ['not-approval', 'approval'],
    },
];

export enum ResidenceType {
    COUNTRY = 'COUNTRY',
    REGION = 'REGION',
    CITY = 'CITY',
}

// TODO merge with to resources/survey
export const RESIDENCE_TYPE_LABEL = {
    [ResidenceType.COUNTRY]: 'Страна',
    [ResidenceType.REGION]: 'Регион',
    [ResidenceType.CITY]: 'Город',
};

export interface DateFormat {
    label: string;
    format: string;
}

export const EMPTY_PAGE_ID = -1;

export type QuestionValue = string | number;

export interface QuestionValues {
    value: QuestionValue;
    value2?: QuestionValue;
    value3?: QuestionValue;
}

export const QuestionValuesKeys: Set<keyof QuestionValues> = new Set(['value', 'value2', 'value3']);

export enum FileUploadType {
    ANY = 'any',
    RESTRICTED = 'restricted',
}

export const DateFormat: Array<DateFormat> = [
    {
        label: `25.11.${currentYear}`,
        format: 'dd.MM.yyyy',
    },
    {
        label: `11.25.${currentYear}`,
        format: 'MM.dd.yyyy',
    },
    {
        label: `${currentYear}.11.25`,
        format: 'yyyy.MM.dd',
    },
];

export const createSelectTypeQuestion = (pageId: number): Question => ({
    ...cloneDeep(initialQuestion),
    expand: true,
    previewMode: true,
    typeMode: true,
    isNew: true,
    id: tempId(),
    pageId,
    name: 'Выберите тип вопроса',
    type: QuestionType.DEFAULT,
    rows: [],
    cols: [],
    params: cloneDeep(initialQuestion.params),
});

export const createTypeSelectQuestion = (pageId: number): Partial<Question> => ({
    expand: true,
    previewMode: true,
    typeMode: true,
    id: tempId(),
    pageId: pageId || EMPTY_PAGE_ID,
    name: 'Выберите тип вопроса',
    type: QuestionType.DEFAULT,
    rows: [],
    cols: [],
    params: cloneDeep(initialQuestion.params),
});
